<div *ngIf="data.length; else emptyChart" [id]="id" style="width: 100%;" [ngStyle]="{'height.px': height}"></div>
<ng-template #emptyChart>
  <zp-chart-error [height]="height" message="No traffic reported" />
</ng-template>
